import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

interface CatalogQtyStepperProps {
  quantity: number;
  onDecrement: () => void;
  onIncrement: () => void;
  /** Обеден продукт без оставащи порции — „+" е блед. */
  incrementDimmed?: boolean;
}

/**
 * Компактният степер на каталога (списък и грид): − N + в една рамка.
 * Рендира се само при маркирано количество — родителят решава.
 * onMouseDown preventDefault — да НЕ открадне фокуса от търсачката на
 * телефон/десктоп (иначе клавиатурата се затваря при всяко +/−); кликът си
 * минава нормално. stopPropagation — кликът по бутон не е клик по реда (+1);
 * цифрата и разделителят не го спират — както в стария степер.
 */
export const CatalogQtyStepper = ({
  quantity,
  onDecrement,
  onIncrement,
  incrementDimmed = false,
}: CatalogQtyStepperProps) => {
  const runAndBlur = (action: () => void) => (e: React.MouseEvent) => {
    e.stopPropagation();
    action();
    (e.currentTarget as HTMLElement).blur();
  };
  // −/+ са antd SVG икони (текстовите глифи висят под центъра
  // заради baseline-а); височината е тази на реда-степер отпреди (32px).
  const buttonClass =
    "h-full w-7 grid place-items-center p-0 bg-transparent cursor-pointer";

  return (
    <span
      className="inline-flex h-8 shrink-0 items-center overflow-hidden rounded-[9px] border border-pos-ctl bg-pos-card"
    >
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={runAndBlur(onDecrement)}
        className={`${buttonClass} text-pos-dim`}
      >
        <MinusOutlined className="text-[11px]" />
      </button>
      {/* Цифрата е с размера на цената в края на реда */}
      <span className="min-w-[22px] text-center font-pos-mono text-base font-semibold text-pos-ink">
        {quantity}
      </span>
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={runAndBlur(onIncrement)}
        className={`${buttonClass} text-pos-accent-ink ${incrementDimmed ? "opacity-40" : ""}`}
      >
        <PlusOutlined className="text-[11px]" />
      </button>
    </span>
  );
};
